export default __webpack_public_path__ + "static/media/alert-white.e98a6deb.svg";